import React from "react";

const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <path
        d="M9.01885 19.0002C4.61038 19.0002 1 15.5174 1 11.2648C1 8.22201 2.63417 5.58247 5.25645 4.29936C5.29446 4.29936 5.33246 4.2627 5.37047 4.2627C5.40847 4.2627 5.40847 4.2627 5.44647 4.2627C5.52248 4.29936 5.56049 4.33602 5.59849 4.40934C5.63649 4.48266 5.63649 4.55598 5.59849 4.59264C5.56049 4.66596 5.52248 4.70262 5.44647 4.73928C3.01421 5.91241 1.49405 8.40531 1.49405 11.2282C1.49405 15.2241 4.83841 18.4502 8.98085 18.4502C13.1233 18.4502 16.4676 15.2241 16.4676 11.2282C16.4676 8.40531 14.9475 5.94907 12.5532 4.73928C12.4392 4.66596 12.3632 4.51932 12.4392 4.40934C12.5152 4.29935 12.6672 4.22603 12.7813 4.29936C15.3655 5.58247 16.9997 8.22201 16.9997 11.2282C17.0377 15.5541 13.4273 19.0002 9.01885 19.0002Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path d="M9 1V7.30008" stroke="#3F3F3F" strokeLinecap="round" />
    </svg>
  );
};

export default LogoutIcon;
